// ===========================================
// AppDayjsLocalizationProvider
// ===========================================
// The dayjs counterpart of `AppLocalizationProvider`, for the five
// `components/reports/*Filters.tsx` date filters. Same rule: this is the ONLY
// way this app should mount a dayjs MUI picker context.
//
// ⚠️ Why a SECOND wrapper instead of one shared component (or a single theme
// `defaultProps.adapterLocale`): the two adapters take incompatible locale
// types. `AdapterDateFns` wants a date-fns Locale OBJECT; `AdapterDayjs` wants
// a string KEY. A theme can hold only one value, so one setting would fix the
// seven date-fns mounts and silently break these five.
//
// ⚠️ The side-effect import below is load-bearing. `AdapterDayjs` looks the key
// up in `defaultDayjs.Ls` and, on a miss, calls `localeNotFoundWarning()` and
// SILENTLY FALLS BACK TO ENGLISH (`AdapterDayjs.js`) — a console warning and
// MM/DD/YYYY, not a crash. Removing the import therefore reintroduces the exact
// bug this component exists to fix, with no test failure and no visible error.
//
// The reports filters were deliberately NOT migrated to date-fns as part of the
// locale fix: each holds `useState<Dayjs>` and calls `.format('YYYY-MM-DD')` to
// build an API query parameter, and none of the five has a test — a mistake
// there silently returns a report for the wrong date range.

import { ReactNode } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import 'dayjs/locale/en-au'; // registers 'en-au' in dayjs's locale table — do not remove

export interface AppDayjsLocalizationProviderProps {
  children: ReactNode;
}

export function AppDayjsLocalizationProvider({
  children,
}: AppDayjsLocalizationProviderProps) {
  return (
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="en-au">
      {children}
    </LocalizationProvider>
  );
}

export default AppDayjsLocalizationProvider;
